export default {
  // dataUrl: 'http://192.168.100.100:29931/v1/guidance/location/search?plateNo=',
  // imgUrl: 'http://192.168.100.100/proxy-binzary/',
  // cropMapUrl: 'http://192.168.100.107:45000/crop',
  // mapUrl: 'http://192.168.100.107:45000/fullsize',
  dataUrl: (siteId) => `https://skt.binzary.com:9931/v1/guidance/location/search?siteId=${siteId}&plateNo=`,
  siteIdUrl: 'https://skt.binzary.com:9931/v1/guidance/location/sites?hostEnc=',
  imgUrl: 'https://skt.binzary.com:9932/',
  cropMapUrl: 'https://skt.binzary.com:45000/crop',
  mapUrl: 'https://skt.binzary.com:45000/fullsize',
};